module.exports = __webpack_public_path__ + "5c743d3155fc769224a108704bd6c090.png";


//////////////////
// WEBPACK FOOTER
// ./images/plashka.png
// module id = 62
// module chunks = 0